import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
} from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import useNotificationProvider from "hooks/notificationBar/useNotificationProvider";
const AddAvailableTimeModal = ({ open, handleClose, onSave }) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());

    const { notifySuccess, notifyError, notifyWarning } =
        useNotificationProvider();
    const handleSubmit = async () => {
        onSave({
            Date: selectedDate.toISOString().split("T")[0], // format to YYYY-MM-DD

            start_time: startTime.toTimeString().split(" ")[0], // format to HH:MM:SS
            end_time: endTime.toTimeString().split(" ")[0],
            IsBooked: false,
        });
        // Close the modal after saving
        console.log("selectedDate :>> ", selectedDate);
        notifySuccess("Time Added Successfully");
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Add Available Time</DialogTitle>
            <DialogContent>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <DatePicker
                                renderInput={(props) => (
                                    <TextField {...props} />
                                )}
                                label="Select Date"
                                value={selectedDate}
                                onChange={(newValue) => {
                                    setSelectedDate(newValue);
                                    console.log("newValue :>> ", newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TimePicker
                                renderInput={(props) => (
                                    <TextField {...props} />
                                )}
                                label="Start Time"
                                value={startTime}
                                onChange={(newValue) => setStartTime(newValue)}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TimePicker
                                renderInput={(props) => (
                                    <TextField {...props} />
                                )}
                                label="End Time"
                                value={endTime}
                                onChange={(newValue) => setEndTime(newValue)}
                            />
                        </Grid>
                    </Grid>
                </LocalizationProvider>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddAvailableTimeModal;
